import { IAddressDatum } from "../service/activity/interface";


export default {
  // 格式化日期
  formatDate(dateStr: string) {
    if (!dateStr) return dateStr;
    const date = new Date(dateStr.replace(/-/g, "/"));
    return [date.getFullYear(), date.getMonth() + 1, date.getDate()]
      .map((item) => {
        return item < 10 ? `0${item}` : item;
      })
      .join(".");
  },

  // 预加载图片
  loadImg(src: string) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        resolve(img);
      };
      img.onerror = () => {
        reject("图片加载过时");
      };
      img.src = src;
    });
  },

  // 复制到剪切板
  copyToClipboard(str: string) {
    var el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    var selected =
      document.getSelection()!.rangeCount > 0
        ? document.getSelection()!.getRangeAt(0)
        : false;

    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    if (selected) {
      document.getSelection()!.removeAllRanges();
      document.getSelection()!.addRange(selected);
    }
  },

  // find，返回第一个为真的元素的索引值
  findIndex<T>(arr: T[], iteratorFunc: (datum: T) => boolean) {
    for (var currIndex = 0; currIndex < arr.length; currIndex++) {
      if (iteratorFunc(arr[currIndex])) {
        return currIndex;
      }
    }
    return -1;
  },

  // 获取url最后的参数
  getUrlParamMap() {
    var query = window.location.search.substring(1);
    var params = query.split("&");
    var paramMap: Record<string, string> = {};
    for (var i = 0; i < params.length; i++) {
      var pair = params[i].split("=");
      paramMap[pair[0]] = pair[1];
    }
    return paramMap;
  },

  /**
   * 判断地址是否为空
   * address任意一项有值，即表明已填写过地址
   */
  isAddressEmpty(address: IAddressDatum) {
    return !(
      address.user_name ||
      address.user_phone ||
      address.province_name ||
      address.city_name ||
      address.city_name ||
      address.address_detail
    );
  },
};
